import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM15.5633 6.99519C15.8368 6.6841 15.8063 6.21021 15.4952 5.93672C15.1841 5.66323 14.7102 5.69372 14.4367 6.00481L8.75816 12.4642L5.47167 9.80577C5.14963 9.54527 4.67738 9.59517 4.41689 9.91721C4.15639 10.2393 4.20628 10.7115 4.52833 10.972L8.37448 14.0831C8.68722 14.3361 9.14385 14.2973 9.40944 13.9952L15.5633 6.99519Z",
  fill: "#12D393"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }